exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-foot {\n    background: #e2ebf8 !important;\n    color: black !important;\n}\n\n.title-tr td {\n    text-align: left !important;\n}\n\ntd{\n    text-align: center;\n}\n\n.titulos-th th{\n    font-size: 1.1em;\n    font-weight: 600 !important;\n    text-align: left !important;\n}\n\n.tebela-th th{\n    font-size: 1.1em;\n    font-weight: 600 !important;\n}\n\n.titles-fim-pag{\n    font-size: 1.1em;\n    font-weight: bold !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/financeiro/ir-fracao-patrimonial/ir-fracao-patrimonial-detalhes/ir-fracao-patrimonial-detalhes.component.css
// module id = ../../../../../src/app/area-restrita/financeiro/ir-fracao-patrimonial/ir-fracao-patrimonial-detalhes/ir-fracao-patrimonial-detalhes.component.css
// module chunks = main